<template>
    <CardEmpty
        :title="title"
        :subtitle="subtitle"
        :icon="icon"
        :cta-label="ctaLabel"
        @add="$emit('add')"
    />
</template>

<script>
import { CardEmpty } from "@easy/ui/cards";

export default {
    components: {
        CardEmpty,
    },
    emits: ["add"],
    props: {
        title: String,
        subtitle: String,
        icon: Object,
        ctaLabel: String,
    },
};
</script>
